// How many labels a selected product prints: the count entered on its card,
// else 1. It used to fall back to stock on hand, which read as "prints what
// we have in stock" and printed 40 labels for a card nobody typed into
// (Rhys 2026-09-03). The count staff choose is the only count that prints.
export const resolveLabelQuantity = (labelQty) => {
  return Math.max(1, parseInt(labelQty, 10) || 1);
};
